// extracted by mini-css-extract-plugin
export var customSlider = "styles-module--customSlider--393e5";
export var description = "styles-module--description--c0dac";
export var field = "styles-module--field--2cfbc";
export var inputField = "styles-module--inputField--01eda";
export var inputLabel = "styles-module--inputLabel--d0474";
export var inputWapper = "styles-module--inputWapper--63d33";
export var sliderMinMax = "styles-module--sliderMinMax--cdf89";
export var title = "styles-module--title--6d753";
export var titlesContainer = "styles-module--titlesContainer--e80d1";